import { Injectable } from "@angular/core";

export const MapsApiKey = "AIzaSyAH879wq68DABdDN-UlzIXHPSu8ml08W-w";

@Injectable({ providedIn: "root" })
export class GoogleMapsLoaderService {
    private static loadingPromise: Promise<void>;

    load(): Promise<void> {
        if (GoogleMapsLoaderService.loadingPromise) {
            return GoogleMapsLoaderService.loadingPromise;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${MapsApiKey}&libraries=places`;
        script.async = true;
        script.defer = true;

        GoogleMapsLoaderService.loadingPromise = new Promise<void>((resolve, reject) => {
            script.onload = () => resolve();
            script.onerror = (err) => reject(err);
        });

        document.head.appendChild(script);
        return GoogleMapsLoaderService.loadingPromise;
    }
}
